export default "__VITE_ASSET__dd17f375__"